import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { SessionTimeoutService } from 'src/app/core/auth/services/session-timeout.service';

export const sessionTrackingInterceptor: HttpInterceptorFn = (req, next) => {
	const sessionService = inject(SessionTimeoutService);

	return next(req).pipe(
		tap((event) => {
			if (event instanceof HttpResponse) {
				const timeoutHeader = event.headers.get('X-Session-Timeout');
				if (timeoutHeader) {
					sessionService.setSessionTimeout(timeoutHeader);
				}
			}
		})
	);
};
